import { IconProps } from "./Icons";

export const IconClose = ({ width = 16, height = 17, color = "white" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M13.024 13.5102C13.4364 13.0982 13.4364 12.4305 13.024 12.0185L9.4901 8.4881L13.024 4.9577C13.4364 4.5457 13.4293 3.88509 13.024 3.47309C12.6187 3.06109 11.9503 3.06819 11.5379 3.47309L8.004 7.00348L4.47008 3.48019C4.05767 3.06819 3.38928 3.06819 2.97687 3.48019C2.56446 3.89219 2.56446 4.55991 2.97687 4.97191L6.51079 8.5023L2.97687 12.0256C2.56446 12.4376 2.56446 13.0982 2.96976 13.5173C3.37506 13.9293 4.04345 13.9293 4.46297 13.5244L8.004 9.99402L11.5379 13.5244C11.9503 13.9364 12.6187 13.9364 13.0311 13.5244L13.024 13.5102Z"
        fill={color}
      />
    </svg>
  );
};
